import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_OMPLIR_DADES
} from '../../../actions/actionTypes';

const ESTAT_INICIAL = null;

const idUsuariSeleccionat = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_OMPLIR_DADES:
            return action.idUsuari;

        default:
            return state;
    }
};

export default idUsuariSeleccionat;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/idUsuariSeleccionat.js